import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import NotAllowed from '../../components/NotAllowed';

export const REQUESTED_LINK_ON_LOGIN = 'requested_link_on_login';

const ProtectedRoute = ({
  component: Component,
  blocked,
  loggedIn,
  redirectTo,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (!loggedIn) {
        // eslint-disable-next-line react/prop-types
        const requestedLink = props.location.pathname + props.location.search;
        localStorage.setItem(REQUESTED_LINK_ON_LOGIN, requestedLink);
        return <Redirect to="/login" />;
      }
      if (redirectTo && blocked) return <Redirect to={redirectTo} />;
      return !blocked ? (
        <Component {...props} blocked={blocked} />
      ) : (
        <NotAllowed />
      );
    }}
  />
);

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  blocked: PropTypes.bool,
  loggedIn: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string.isRequired
};

ProtectedRoute.defaultProps = {
  blocked: false
};

export default ProtectedRoute;
